module.exports = __webpack_public_path__ + "static/media/copilot_ai.ae88c70c.png";